
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resume",
      function () {
        return require("private-next-pages/resume/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resume"])
      });
    }
  